import { render, staticRenderFns } from "./ConfigReportGeneral.vue.js?vue&type=template&id=06bc5dd4!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ConfigReportGeneral.vue?vue&type=template&id=06bc5dd4"
import script from "./ConfigReportGeneral.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ConfigReportGeneral.vue?vue&type=script&lang=js"
export * from "./ConfigReportGeneral.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ConfigReportGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports